import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-items mb-20" }
const _hoisted_2 = { class: "ap-input-group" }
const _hoisted_3 = { class: "mb-20" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "ap-input-label" }
const _hoisted_6 = ["placeholder"]

import { ModalBeforeOpenEventTyped } from '@/models/Interfaces';
    import { SendSmsModel } from '@/models/SMS';
    import { api } from '@/services/Api';
    import Swal from 'sweetalert2';
    import { inject, ref } from 'vue';
    import { VueFinalModalProperty } from 'vue-final-modal';
    import { useI18n } from 'vue-i18n';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'SendTestSms',
  props: {
        name: {
            type: String,
            required: true,
        },
    },
  setup(__props) {

const props = __props;

    const { t } = useI18n();
    const $vfm = inject('$vfm') as VueFinalModalProperty;

    
    const phoneNumber = ref('');
    const settings = ref(new SendSmsModel());

    async function beforeOpen(event: ModalBeforeOpenEventTyped<SendSmsModel>) {
        phoneNumber.value = '';
        if (!event.params.Message) {
            $vfm.hide(props.name);
        }
        settings.value.Message = event.params.Message || '';
        settings.value.ReplaceLink = event.params.ReplaceLink || false;
        settings.value.SmsProfileId = event.params.SmsProfileId || null;
        settings.value.AddUnsubscribe = event.params.AddUnsubscribe || false;
        settings.value.UnsubscribeText = event.params.UnsubscribeText || null;
    }
    function handleOnKeypress(event: any) {
        if (event.key.trim() === '' || /^[0-9.+]+$/.test(event.key.toString()) === false) {
            event.preventDefault();
        }
    }
    async function sendTestSms() {
        if (!phoneNumber.value) {
            Swal.fire({
                icon: 'error',
                text: t('page.send-sms.testSmsModal.alert') as string,
            });
            return;
        }

        //TO DO send test SMS
        Swal.showLoading();
        var resp = await api.SendTestSMS({
            Mobile: phoneNumber.value,
            Message: settings.value.Message,
            ReplaceLink: settings.value.ReplaceLink,
            SmsProfileId: settings.value.SmsProfileId,

            AddUnsubscribe: settings.value.AddUnsubscribe,
            UnsubscribeText: settings.value.UnsubscribeText,
        });
        if (resp.Error || !resp.Data) {
            Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
            return;
        }

        const swal = await Swal.fire({
            icon: 'success',
            text: t('page.send-sms.alert.testSend') as string,
            showCloseButton: true,
        }).then(() => $vfm.hide(props.name));
    }

return (_ctx: any,_cache: any) => {
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_ApModalBase = _resolveComponent("ApModalBase")!

  return (_openBlock(), _createBlock(_component_ApModalBase, {
    name: __props.name,
    titleIcon: 'ap-icon-logo',
    title: _ctx.$t('page.send-sms.testSmsModal.title'),
    showClose: true,
    width: 475,
    height: null,
    onOpen: beforeOpen,
    "cancel-text": _ctx.$t('modal.close')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ap_button, {
        "btn-class": "btn-primary",
        onClick: sendTestSms,
        disabled: !phoneNumber.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('page.send-sms.testSmsModal.sendBtn')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("textarea", {
              value: settings.value.Message || '',
              disabled: true,
              class: "w-100"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('page.send-sms.testSmsModal.input-title')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "ap-input w-100",
            placeholder: _ctx.$t('page.send-sms.testSmsModal.placeholder'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber).value = $event)),
            onKeypress: _cache[1] || (_cache[1] = ($event: any) => (handleOnKeypress($event)))
          }, null, 40, _hoisted_6), [
            [_vModelText, phoneNumber.value]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["name", "title", "cancel-text"]))
}
}

})